var exports = {
  "kL": "container__riAAIZ",
  "Qs": "content__4ugqJh",
  "yZ": "collapsed__pOz4Y6",
  "K5": "inertWrapper__GcV84G",
  "L$": "toggle___yOqb0",
  "X": "toggleFloating__Fy6AY2",
};

module.exports = exports;
